module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"ClosedDate":"Date de clôture","CommentCount":"Nombre de commentaires","CreationDate":"Date de création","ID":"ID"}}')
  delete Component.options._Ctor
}
